export class VerticalSlider {
  constructor() {
    this.sliderSection = '[data-vertical-slider_section]';
    this.slider = '[data-vertical-slider]';
    this.slide = '[data-vertical-slider_slide]';
    this.dots = '[data-vertical-slider_dots]';
    this.currentSlide = null;
    this.nextSlide = null;
    this.slideCount = null;
    this.slideActive = true;
    this.sectionVisible = true;
    this.scroll = 0;
    this.activity = true;
    this.count = 0;
    this.activeCount = 0;
    this.visibleCount = [1, 2];
    this.step = 1;
    this.mobileError = 3;
    this.activeScroll = true;
    this.xDown = null;                                                        
    this.yDown = null;
    this.touch = null;
    this.eventListeners();
  }

  eventListeners() {
    let sliderSection = document.querySelector(this.sliderSection);
    if(!sliderSection) {
      return;
    }

    this.initialSlider();

    window.addEventListener('resize', () => this.checkWindowSize());

    $(window).on('scroll.scrollHorisontal', () => this.checkVisibleSlider());

    $(this.sliderSection).on('wheel.sliderHorisontal', (e) => {
        let direction = e.originalEvent.deltaY > 0 ? 'up' : 'down';
        this.checkScrollingSlider(e, direction);
    }); 

    sliderSection.querySelector(this.dots).querySelectorAll('span').forEach((el, index) => {
      el.addEventListener('click', () => this.onDonts(el, index));
    });

    // on mobile swipe
    document.addEventListener('touchstart', (e) => {this.handleTouchStart(e)}, {passive: false});
    this.touch = (e) => this.handleTouchMove(e);
  }

  // initial slider
  initialSlider() {
    this.checkWindowSize();

    let slider = document.querySelector(this.slider);
    let slide = slider.querySelectorAll(this.slide);
  
    this.count = slide.length;
    this.step = this.visibleCount.length;
    this.createDots();
    this.setVisibleSlide(this.activeCount, 'active');
    this.setVisibleDots(this.activeCount);

    // calculate slider height
    let sliderHeight = slide[0].getBoundingClientRect().height;

    slide.forEach((el, index) => {
      sliderHeight = 
      sliderHeight >= slide[index].getBoundingClientRect().height 
      ? sliderHeight 
      : slide[index].getBoundingClientRect().height;
    })

    slider.style.height = sliderHeight + 'px';
  }

  // check visible slider in window
  checkVisibleSlider() {
    if(!this.activeScroll) {
      return
    }

    var st = window.pageYOffset || document.documentElement.scrollTop;
    let elemTop = Math.trunc($(this.sliderSection).offset().top);

    if (
      st >= this.scroll - this.mobileError && this.activeCount + this.step <= this.count - 1 && $(document).scrollTop() + this.mobileError >= elemTop
      ||
      st <= this.scroll + this.mobileError && this.activeCount - this.step >= 0 && $(document).scrollTop() - this.mobileError <= elemTop 
    ) {
      this.activeScroll = false;
      $('html, body').animate({
          scrollTop: elemTop,
      }, 100);
      this.sectionVisible = true;
      this.scroll = elemTop;
      document.addEventListener('touchmove', this.touch, {passive: false});
      setTimeout(() => {
        this.activeScroll = true;
      }, 100);
    } else {
      document.removeEventListener('touchmove', this.touch);
      this.sectionVisible = false;
      this.scroll  = st <= 0 ? 0 : st;
    }
  }

  // scrolling logic
  checkScrollingSlider(e, direction) {
    if(!this.sectionVisible) {
      return
    }

    if(!this.slideActive || !this.activity) {
      e ? e.preventDefault() : null;
      this.disableScroll();
      return
    }

    this.activity = false;
    if (direction === 'up' && this.activeCount + this.step <= this.count - 1) {
      e ? e.preventDefault() : null;
      this.disableScroll();
      $(window).off('scroll.scrollHorisontal');
      this.setNextSlide();
    } else if(direction === 'down' && this.activeCount - this.step >= 0) {
      e ? e.preventDefault() : null;
      this.disableScroll();
      $(window).off('scroll.scrollHorisontal');
      this.setPrevSlide();
    } else {
      window.onscroll = () => {};
      $(window).on('scroll.scrollHorisontal', () => this.checkVisibleSlider());
      document.removeEventListener('touchmove', this.touch);
    }
    this.activity = true;
  }

  // set active slide
  setVisibleSlide(count, className) {
    let slider = document.querySelector(this.slider);
    let slide = slider.querySelectorAll(this.slide);

    this.visibleCount.forEach((el, index) => {
      if(slide[index + this.activeCount]) {
        slide[index + this.activeCount].classList.remove(className);
      }
      if(slide[index + count]) {
        slide[index + count].classList.add(className);
      }
    });
  }

  checkWindowSize() {
    if($(window).width() < 980) {
      this.visibleCount = [1];
    }
  }

  // set active dots
  setVisibleDots(count) {
    let slider = document.querySelector(this.slider);
    let dots = slider.querySelector(this.dots).querySelectorAll('span');
    
    if(dots[Math.floor(this.activeCount / this.step)]) {
      dots[Math.floor(this.activeCount / this.step)].classList.remove('active');
    }
      
    if(dots[count / this.step]) {
      dots[count / this.step].classList.add('active');
    }
  }

  // slide next
  setNextSlide() {
    this.slideActive = false;
    this.setVisibleSlide(this.activeCount + this.step, 'active');
    this.setVisibleSlide(this.activeCount, 'next');
    this.setVisibleDots(this.activeCount + this.step);
    this.activeCount = this.activeCount + this.step;

    // time animation
    setTimeout(() => {
      this.slideActive = true;
    }, 100);
  }

  // slide prev
  setPrevSlide() {
    this.slideActive = false;

    let slider = document.querySelector(this.slider);
    let slide = slider.querySelectorAll(this.slide);

    this.visibleCount.forEach((el, index) => {
      if(!slide[index + this.activeCount - this.step]) {
        return
      }
      slide[index + this.activeCount - this.step].classList.remove('next');
    });
     
    this.setVisibleSlide(this.activeCount - this.step, 'active');
    this.setVisibleDots(this.activeCount - this.step);
    this.activeCount = this.activeCount - this.step;

    // time animation
    setTimeout(() => {
      this.slideActive = true;
    }, 100);
  }

  // create dots
  createDots() {
    let slider = document.querySelector(this.slider);
    let slide = slider.querySelectorAll(this.slide);
    let dots = slider.querySelector(this.dots);

    slide.forEach((el, index) => {
      if(index <= Math.round(this.count / this.step) - 1) {
        dots.appendChild(document.createElement('span'));
      }
    });
  }

  // click on dots
  onDonts(el, index) {
    let count = index * this.step > this.count ? this.count : index * this.step;

    if(count === this.activeCount) {
      return
    }
    el.classList.add('active');

    if(count > this.activeCount) {
      let step = Number((count - this.activeCount) / this.step);
      for (let i = 0; i < step; i++) {
        // time animation
        setTimeout(() => {
          this.setNextSlide();
        }, i * 400);
      }
    } else {
      let step = Number((this.activeCount - count) / this.step);
      for (let i = 0; i < step; i++) {
        // time animation
        setTimeout(() => {
          this.setPrevSlide();
        }, i * 400); 
      }
    } 
  }

  disableScroll() {
    // Get the current page scroll position
    let elemTop = Math.trunc($(this.sliderSection).offset().top);
    let scrollTop = elemTop ? elemTop : window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    
    window.onscroll = function() {
        window.scrollTo(scrollLeft, scrollTop);
    };
  }

  getTouches(evt) {
    return evt.touches ||             // browser API
           evt.originalEvent.touches; // jQuery
  }                                                     
  
  handleTouchStart(evt) {
      const firstTouch = this.getTouches(evt)[0];                                      
      this.xDown = firstTouch.clientX;                                      
      this.yDown = firstTouch.clientY;                                      
  }                                           
  
  handleTouchMove(evt) {
      evt.preventDefault();
      if ( ! this.xDown || ! this.yDown ) {
          return;
      }
       
      var xUp = evt.touches[0].clientX;                                    
      var yUp = evt.touches[0].clientY;
  
      var xDiff = this.xDown - xUp;
      var yDiff = this.yDown - yUp;
  
      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
          if ( xDiff > 0 ) {
              /* left swipe */ 
          } else {
              /* right swipe */
          }                       
      } else {
          if ( yDiff > 0 ) {
              /* up swipe */ 
              this.checkScrollingSlider(false, 'up');
          } else { 
              /* down swipe */
              this.checkScrollingSlider(false, 'down');
          }                                                                 
      }
      /* reset values */
      this.xDown = null;
      this.yDown = null;                                             
  }
}


// WEBPACK FOOTER //
// ./scripts/main-modules/vertical-slider.js